// extracted by mini-css-extract-plugin
export var form = "_3y-0";